<ui-card *ngIf="jerPayrollTaxes">
    <app-segment-header title="Employer Payroll Tax Settings"> </app-segment-header>
    <p>{{ 'reporting.payroll.journalEntry.settingsDescription' | translate }}</p>
    <form class="ui">
        <div class="flex-row">
            <h3 class="ui header">{{ 'reporting.payroll.journalEntry.health-tax-header' | translate }}</h3>
            <mat-slide-toggle
                [checked]="journalEntryReportEmployerHealthTax"
                (change)="toggleEht($event.checked)"
            ></mat-slide-toggle>
            {{ 'reporting.payroll.journalEntry.health-tax-description' | translate }}
        </div>
        <br />
        <div class="flex-row">
            <h3 class="ui header">{{ 'reporting.payroll.journalEntry.workers-comp-header' | translate }}</h3>
            <mat-slide-toggle
                [checked]="journalEntryReportWorkersCompensation"
                (change)="toggleWc($event.checked)"
            ></mat-slide-toggle>
            {{ 'reporting.payroll.journalEntry.workers-comp-description' | translate }}
        </div>
        <br />
        <div class="flex-row">
            <h3 class="ui header">{{ 'reporting.payroll.journalEntry.cnesst-header' | translate }}</h3>
            <mat-slide-toggle
                [checked]="journalEntryReportCnesst"
                (change)="toggleCnesst($event.checked)"
            ></mat-slide-toggle>
            {{ 'reporting.payroll.journalEntry.quebec-only' | translate }}
        </div>
        <br />
        <div class="flex-row">
            <h3 class="ui header">{{ 'reporting.payroll.journalEntry.qhsf-header' | translate }}</h3>
            <mat-slide-toggle
                [checked]="journalEntryReportQhsf"
                (change)="toggleQhsf($event.checked)"
            ></mat-slide-toggle>
            {{ 'reporting.payroll.journalEntry.quebec-only' | translate }}
        </div>
    </form>
</ui-card>
